import { useState, useEffect } from 'react';
import { subscribe } from '../../../services/utils/pubsub';
import { ComponentEvents } from '../../../services/wss/events/ComponentEvents';
import { EngineNames } from '../../../services/wss/events/EngineNames';
import searchQueryEngine from './Core/SearchQueryEngine';

/**
 * Paint hook for SearchQueryEngine.
 * Returns current query — all mutations via searchQueryEngine directly.
 */
export default function useSearchQuery() {
    const [query, setQuery] = useState(() => searchQueryEngine.getQuery());

    useEffect(() => {
        return subscribe(ComponentEvents.channel, (e) => {
            if (e.name !== EngineNames.SearchQueryEngine) return;
            if (e.target !== 'queryChanged') return;
            setQuery(e.data.query);
        });
    }, []);

    return query;
}
